/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "./";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 1);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(16);
__webpack_require__(17);
__webpack_require__(18);
__webpack_require__(19);
__webpack_require__(20);
__webpack_require__(21);
__webpack_require__(22);

__webpack_require__(23);
__webpack_require__(24);

var dialog = __webpack_require__(25);

var QBDown = __webpack_require__(28);
var myGifts = __webpack_require__(29);
var showPrize = __webpack_require__(30);
var shareGetChance = __webpack_require__(31);
var notSub = __webpack_require__(32);
var activtyEnd = __webpack_require__(33);
var userContact = __webpack_require__(34);

var answerEnd = __webpack_require__(35);
var answerNum = __webpack_require__(36);
var littleFollow = __webpack_require__(37);

var userInfoObj = JSON.parse(sessionStorage.getItem("userInfo"));

function mask(type, title, msg, headsrc, width, height) {
  if (type === "QBrowser") {
    console.trace();
    dialog({
      width: 550,
      height: 290,
      body: QBDown({
        title: title,
        msg: msg
      }),
      onclose: function onclose() {},
      onshow: function onshow() {
        if (msg == '请前往电脑参与') {
          $('.pcqb-QBDown-btn').hide();
        }
      }
    }).show();
  } else if (type === "myGifts") {
    dialog({
      width: 820,
      height: 400,
      body: myGifts({}),
      onclose: function onclose() {},
      onshow: function onshow() {
        setTimeout(function () {
          $("#qtips").mouseover(function () {
            $(this).css("overflow", "visible");
          });
          $(".duiRule").mouseout(function () {
            $("#qtips").css("overflow", "hidden");
          });
          $(".duiRuleQr").mouseout(function () {
            $("#qtips").css("overflow", "hidden");
          });
        }, 400);
      }
    }).show();
  } else if (type === "showPrize") {
    dialog({
      width: 550,
      height: 590,
      body: showPrize({})
    }).show();
  } else if (type === "shareGetChance") {
    dialog({
      width: 550,
      height: 290,
      body: shareGetChance({}),
      onclose: function onclose() {
        if (lottery.showNotShare) {
          mask('shareGetChance');
          lottery.showNotShare = false;
        }
      },
      onshow: function onshow() {}
    }).show();
  } else if (type === "notSub") {
    dialog({
      width: 550,
      height: 280,
      body: notSub({}),
      onclose: function onclose() {
        if (lottery.showNotShare) {
          mask('shareGetChance');
          lottery.showNotShare = false;
        }
      }
    }).show();
  } else if (type === "activtyEnd") {
    dialog({
      width: 550,
      height: 280,
      body: activtyEnd({
        title: title,
        msg: msg
      })
    }).show();
  } else if (type === "userCon") {
    dialog({
      width: 550,
      height: 485,
      body: userContact({
        title: title,
        msg: msg
      }),
      onclose: function onclose() {

        var userInfo = {
          "userName": $("#userName").val(),
          "phoneNum": $("#phoneNum").val(),
          "provinceId_m": $("#provinceId_m").val(),
          "cityId_m": $("#cityId_m").val(),
          "areaId_m": $("#areaId_m").val(),
          "detailAddr": $("#detailAddr").val(),
          "zipCode": $("#zipCode").val()
        };
        sessionStorage.setItem("userInfo", JSON.stringify(userInfo));
      },
      onshow: function onshow() {
        if (!window.userInfoObj) {
          //非空校验
          return;
        }
        setTimeout(function () {
          $("#userName").val(userInfoObj["userName"]);
          $("#phoneNum").val(userInfoObj["phoneNum"]);
          $("#provinceId_m").val(userInfoObj["provinceId_m"]);
          $("#cityId_m").val(userInfoObj["cityId_m"]);
          $("#areaId_m").val(userInfoObj["areaId_m"]);
          $("#detailAddr").val(userInfoObj["detailAddr"]);
          $("#zipCode").val(userInfoObj["zipCode"]);
        }, 500);
      }
    }).show();
  } else if (type === "answerEnd") {
    dialog({
      width: 550,
      height: 280,
      body: answerEnd({
        title: title,
        msg: msg
      })
    }).show();
  } else if (type === "answerNum") {
    dialog({
      width: 550,
      height: 380,
      body: answerNum({
        headsrc: headsrc,
        title: title,
        msg: msg
      })
    }).show();
  } else if (type === "littleFollow") {
    dialog({
      width: 550,
      height: 280,
      body: littleFollow({
        title: title,
        msg: msg
      }),
      onshow: function onshow() {
        if (msg === '对不起，你已经抽过奖了') {
          lottery.oneClick = true;
        } else if (msg === '关注满3个主播才可以抽奖喔') {
          lottery.onlyClick = true;
        } else if (msg === '参与活动才有抽奖机会哟~') {
          lottery.onlyClick = true;
        }
      },
      onclose: function onclose() {
        if (msg == '你还有抽奖机会待领取') {
          $("html,body").animate({ scrollTop: 830 }, 200);
        }
      }
    }).show();
  }
}

module.exports = mask;

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var config = __webpack_require__(2);
var utils = __webpack_require__(14);
var request = __webpack_require__(15);
var iBorad = __webpack_require__(38);
__webpack_require__(39);
var mask = __webpack_require__(0);

_qblog.setting({ key: 20016, tcss: true });

//AMS新集成
zHttp.baseUrl = "http://iyouxi3.vip.qq.com/ams3.0.php";
//活动地址 不带任何参数
var _pageUrl = location.protocol + '//' + location.host + location.pathname;

var qb_guid = 0; // window.external.getGuid 有可能不返回数据
var getGuid = function getGuid() {
  try {
    //  var guid = qbsdk.getServerGuid();
    qb_guid = qbsdk.getGuid();
    console.log("guid--->" + qb_guid);
  } catch (e) {
    var web_page_extension_id = '{A3C609B3-3E61-4508-8953-117B7286068B}';
    var platform_extension_id = '{420DEFEE-20A8-468C-BFDA-61A09A99325D}';
    var extension;
    try {
      extension = window.getExtension(web_page_extension_id);
      extension.sendMessage(platform_extension_id, { serviceId: "hardware.getGuid", args: [] }, function (data) {
        qb_guid = data[0].split('-').join('');
      });
    } catch (e) {
      qb_guid = 0;
    }
  }
};
getGuid();

function hint() {
  var qb_dialog = new qv.zero.Dialog({
    title: "QQ浏览器用户专享",
    content: "<p style='color: #333'>       亲，这是QQ浏览器用户的专属特权活动。</p><p style='color: #333'>             用QQ浏览器打开即可参加。</p>",
    type: "alert",
    buttons: [{
      text: "下载QQ浏览器",
      click: function click() {
        document.getElementById('downloadQBBtn').click();
        qb_dialog.hide();
      }
    }]
  });
  hint = function hint() {
    qb_dialog.show();
  };
  qb_dialog.show();
}

var reportDownloadQB = function reportDownloadQB() {
  var adtag = zURL.get('ADTAG');
  if (adtag) {
    _qblog.wsd.click('BROWSER.ACTIVITY.DNF201808.QBDOWNLOADCLICK_' + adtag);
  }
  _qblog.wsd.click('BROWSER.ACTIVITY.DNF201808.QBDOWNLOADCLICK');
};

var jumentBrowser = function jumentBrowser() {
  return (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent) || /(Android)/i.test(navigator.userAgent)
  );
};(function (window, $) {
  function getQBVersion() {
    var version = 0;
    try {
      try {
        version = window.external.getVersion() || 1;
      } catch (e) {
        version = window.external.getbrowserversion() || 1;
      }
    } catch (e) {
      if (/QQBrowser/.test(navigator.userAgent)) {
        version = 1;
        try {
          version = /QQBrowser\/([\d.]+)\b/.exec(navigator.userAgent)[1];
          if (version === '9.0.2524.400') {
            version = 0;
          }
        } catch (e) {}
      }
    }
    if (jumentBrowser()) {
      version = 0;
    }
    return version;
  }
  function isQQBrowser() {
    var version = getQBVersion();
    var result = version !== 0;
    return result;
  }
  window.isQQBrowser = isQQBrowser();
})(window, jQuery);
window.setUserContact = function () {
  userAddress.getUserInfo(function (res) {
    var userDialog = new qv.zero.Dialog({
      title: "填写联系方式",
      content: userAddress.tempContact(res),
      type: "show",
      buttons: [{
        text: "提交",
        click: function click() {
          userAddress.submitUserInfo("userName", "phoneNum", "detailAddr", "zipCode", function () {
            alert("保存成功！");
            userDialog.hide();
          });
        }
      }]
    });
    userDialog.show();
  });
};
//签到 设置按钮 显示天数
function setMoney(demo, m) {
  var me = jQuery(demo);
  var meVal = parseInt(me.text());
  var k = 0;
  if (parseInt(m) < 0) {
    k = meVal + parseInt(m);
  } else if (m === '++') {
    k = meVal + 1;
  } else if (m === '--') {
    k = meVal - 1;
  } else if (!isNaN(m)) {
    if (m.toString().indexOf('-') >= 0 || m.toString().indexOf('+') >= 0) {
      k = meVal + parseInt(m);
    } else {
      k = m;
    }
  }
  if (k < 0) {
    k = 0;
  }
  me.text(k);
}

/*分页*/
(function (window, $) {

  var me = {
    init: function init(args) {
      return function () {
        args.pageCount = parseInt((args.dataContainer.length - 1) / args.perPage) + 1;
        me.fillHtml(args);
        me.bindEvent(args);
      }();
    },
    //填充html
    fillHtml: function fillHtml(args) {
      return function () {
        args.liftsContainer.empty();
        args.pageContainer.empty();
        //第一页
        if (args.firstAndLast) {
          if (args.current > 1) {
            args.pageContainer.append('<a href="javascript:;" class="firstPage">第一页</a>');
          } else {
            args.pageContainer.append('<span class="disabled">第一页</span>');
          }
        }
        //上一页
        if (args.current > 1) {
          args.pageContainer.append('<a href="javascript:;" class="prevPage">上一页</a>');
        } else {
          args.pageContainer.remove('.prevPage');
          args.pageContainer.append('<span class="disabled">上一页</span>');
        }
        //中间页码
        args.pageContainer.append('<span>第' + args.current + '/' + args.pageCount + '页</span>');
        //下一页
        if (args.current < args.pageCount) {
          args.pageContainer.append('<a href="javascript:;" class="nextPage">下一页</a>');
        } else {
          args.pageContainer.remove('.nextPage');
          args.pageContainer.append('<span class="disabled">下一页</span>');
        }
        //最后一页
        if (args.firstAndLast) {
          if (args.current < args.pageCount) {
            args.pageContainer.append('<a href="javascript:;" class="lastPage">最后一页</a>');
          } else {
            args.pageContainer.append('<span class="disabled">最后一页</span>');
          }
        }
        //列表
        var _star = (args.current - 1) * args.perPage,
            _end = args.current * args.perPage;
        args.liftsContainer.append(args.dataContainer.slice(_star, _end).join(''));
        if (typeof args.backFn == "function") {
          args.backFn({ current: args.current });
        }
      }();
    },
    //绑定事件
    bindEvent: function bindEvent(args) {
      return function () {
        //上一页
        args.pageContainer.on("click", "a.prevPage", function () {
          if (args.current > 1) {
            args.current--;
          }
          me.fillHtml(args);
        });
        //下一页
        args.pageContainer.on("click", "a.nextPage", function () {
          if (args.current < args.pageCount) {
            args.current++;
          }
          me.fillHtml(args);
        });
        //第一页、最后一页
        if (args.firstAndLast) {
          args.pageContainer.on("click", "a.firstPage", function () {
            args.current = 1;
            me.fillHtml(args);
          });
          args.pageContainer.on("click", "a.lastPage", function () {
            args.current = args.pageCount;
            me.fillHtml(args);
          });
        }
      }();
    }
  };
  window.createPage = function (options) {
    var args = $.extend({
      dataContainer: [],
      liftsContainer: $('#liftsContainer'), //列表容器
      pageContainer: $('#pageContainer'), //分页容器
      perPage: 10, //每页显示数
      pageCount: 0, //总页数
      current: 1, //当前页码
      startPage: 1, //初始页
      firstAndLast: false, //是否显示第一页、最后一页
      backFn: function backFn() {}
    }, options);
    me.init(args);
  };
})(window, jQuery);

//main
var Page = qv.zero.extend(qv.zero.AbstractPage, {
  // 项目ID
  userJsonID: 311522, //极为重要，如果活动id 不对，整个页面不响应 事件
  preloads: ["AreaSvrSelector"],
  loadExtHandler: true,
  init: function init() {
    Page.superclass.init.apply(this, arguments);
  },
  initEvent: function initEvent() {
    Page.superclass.initEvent.apply(this, arguments);
    $('body').on('click', 'a[href="#"]', function (e) {
      e.preventDefault();
    });
    page.svr = new qv.zero.AreaSvrSelector({
      game: 'dnf'
    });
    if (!!qq.login.getUin()) {
      page.queryGold();
      page.querySilver();
      page.queryDays();
    }
    qq.login.bind('login', function () {
      page.queryGold();
      page.querySilver();
      page.queryDays();
    });
    qq.login.bind('logout', function () {
      setMoney('#day', 0);
      setMoney('#chance', 0);
      $('.silver').removeClass('open');
      $('.openGold').removeClass('open');
      $('.openSilver').removeClass('open');
      $('.gold').removeClass('open');
    });

    $(".feed .feedBack").click(function () {
      _qblog.wsd.click("RELEASEMEBABY.SUPPORT");
    });
  }, //initEvent 结束
  //领取礼包
  exchange: function exchange(e, act) {
    var actArr = [311722, 311705, 311617],
        // 最好一个 QQ浏览器签到礼包
    index = act[0],
        _actid = actArr[index];

    if (!isQQBrowser) {
      hint();
      return;
    }
    if (!qb_guid) {
      getGuid();
    }
    zUtil.ensureLogin(function () {
      page.svr.show({
        send: function send(args, callb) {
          zHttp.send({ actid: _actid, area: args.area, roleid: args.roleid, guid: qb_guid }, function (res) {
            if (res.ret == 0) {
              zHttp.showResponse(res, res.actid, $.noop);
              // zMsg.dialog("恭喜你获得CDKey,CDKey是："+res.data.op.cdkey,"dnf-dark",[
              //     {
              //       text: "去兑换",
              //       click: function() {
              //         window.open("http://dnf.qq.com/gift.shtml")
              //       }
              //     }
              //   ]);
            } else if (res.ret == 10002) {
              qq.login.open();
            } else if (res.ret == 10001 || res.ret == 10004) {
              zMsg.alert("活动已经结束，敬请期待更多QQ浏览器特权活动！");
            } else {
              zHttp.showResponse(res, res.actid, $.noop);
            }
            console.log("exchange--id-->" + _actid);
            console.log(res.ret);
          });
        }
      });
    });
    _qblog.wsd.click('BROWSER.ACTIVITY.DNF201808.EXCHANGE_' + index);
  },
  signin: function signin() {
    if (!isQQBrowser) {
      return;
    }
    zHttp.send({ actid: 311748 }, function (res) {
      if (res.ret == 0) {
        setMoney('#day', '++');
      }
    });
  },
  queryGold: function queryGold() {
    zHttp.send({ actid: 311746 }, function (res) {
      if (res.ret == 0) {
        if (res.data.op.join['311538'] > 0) {
          //终极冲奖id
          // $('.gold').addClass('open');
          // $('.openGold').addClass('open');
          console.log("gold box is opened!!!");
        }
      }
    });
  },
  querySilver: function querySilver() {
    //查询每天是否领取
    zHttp.send({ actid: 311745 }, function (res) {
      if (res.ret == 0) {
        if (res.data.op.join['311542'] > 0) {
          //每天抽奖
          $('.silver').addClass('open');
          $('.openSilver').addClass('open');
          console.log("already has -->" + 311745);
        }
        console.log("not --has -->" + 311745);
      }
    });
  },
  //查询登录天数，抽奖天数
  queryDays: function queryDays() {
    zUtil.ensureLogin(function () {
      zHttp.send({ actid: 311744 }, function (res) {
        if (res.ret == 0) {
          var m = res.data.op;
          setMoney('#day', m);
          var t = res.data.rule.join_level;
          setMoney('#chance', t);
        } else {
          console.warn("查询天数 失败 " + res.ret);
        }
        page.signin();
      });
    });
  },
  //打开宝箱动画
  openBX: function openBX(cb, flag) {
    if (flag == 1) {
      $('.silver').addClass('open');
      $('.openSilver').addClass('open');
      setTimeout(function () {
        cb();
      }, 200);
    } else if (flag == 2) {
      $('.gold').addClass('open');
      $('.openGold').addClass('open');
      setTimeout(function () {
        cb();
      }, 200);
    }
  },
  getLuckySilver: function getLuckySilver(e, act) {
    if (!isQQBrowser) {
      hint();
      return;
    }
    if (!qb_guid) {
      getGuid();
    }
    // if($('.silver').hasClass('open')) {
    //   return;
    // }
    zUtil.ensureLogin(function () {
      page.svr.show({
        send: function send(args, callb) {
          //每天抽奖
          // 记录奖品时 必须加字段 _record_gift_flow : 1 ， 若记录末等奖时 再加字段(不记录则不加) _record_def_gift : 1
          zHttp.send({ actid: 311542, area: args.area, roleid: args.roleid, guid: qb_guid, _record_gift_flow: 1, _record_def_gift: 1 }, function (res) {
            if (res.ret == 0) {
              setMoney('#chance', '++');
              page.openBX(function () {
                zHttp.showResponse(res, res.actid, $.noop);
              }, 1);
            } else if (res.ret == 10002) {
              qq.login.open();
            } else if (res.ret == 10001 || res.ret == 10004) {
              zMsg.alert("活动已经结束，敬请期待更多QQ浏览器特权活动！");
            } else {
              zHttp.showResponse(res, res.actid, $.noop);
            }
            console.log('silver--->' + res.ret);
          });
        }
      });
    });
    _qblog.wsd.click('BROWSER.ACTIVITY.DNF201808.GETLUCKYSILVERCLICK');
  },
  getLuckyGold: function getLuckyGold(e, act) {
    if (!isQQBrowser) {
      hint();
      return;
    }
    if (!qb_guid) {
      getGuid();
    }
    // if($('.gold').hasClass('open')) {
    //   return;
    // }
    zUtil.ensureLogin(function () {
      page.svr.show({
        send: function send(args, callb) {
          // 记录奖品时 必须加字段 _record_gift_flow : 1 ， 若记录末等奖时 再加字段(不记录则不加) _record_def_gift : 1
          zHttp.send({ actid: 311538, area: args.area, roleid: args.roleid, guid: qb_guid, _record_gift_flow: 1, _record_def_gift: 1 }, function (res) {
            if (res.ret == 0) {
              page.openBX(function () {
                zHttp.showResponse(res, res.actid, $.noop);
              }, 2);
            } else if (res.ret == 10002) {
              qq.login.open();
            } else if (res.ret == 10001 || res.ret == 10004) {
              zMsg.alert("活动已经结束，敬请期待更多QQ浏览器特权活动！");
            } else {
              zHttp.showResponse(res, res.actid, $.noop);
            }
          });
        }
      });
    });
    _qblog.wsd.click('BROWSER.ACTIVITY.DNF201808.GETLUCKYGOLDCLICK');
  },
  //查询中奖记录
  queryRecord: function queryRecord() {
    zUtil.ensureLogin(function () {
      zHttp.send({ actid: 311747 }, function (res) {
        var testOp = '';
        //             testOp = [{
        //     "key": 0,
        //     "val": {
        //         "actid": 276370,
        //         "status": 0,
        //         "type": 1,
        //         "is_life_coupon": "0",
        //         "qqvipCardId": 0,
        //         "time": 1524549748,
        //         "endTime": "-",
        //         "name": "\u6df1\u6e0a\u6d3e\u5bf9\u901a\u884c\u8bc1*6",
        //         "level": 5,
        //         "info": "EGWLMAAAAAAdatbe"
        //     }
        // }, {
        //     "key": 1,
        //     "val": {
        //         "actid": 276362,
        //         "status": 0,
        //         "type": 1,
        //         "is_life_coupon": "0",
        //         "qqvipCardId": 0,
        //         "time": 1524553109,
        //         "name": "\u6d4f\u89c8\u5668\u4e13\u5c5e\u793c\u5305",
        //         "level": 4,
        //         "info": "EGWANAAAAAAbF"
        //     }
        // }, {
        //     "key": 2,
        //     "val": {
        //         "actid": 276364,
        //         "status": 0,
        //         "type": 1,
        //         "is_life_coupon": "0",
        //         "qqvipCardId": 0,
        //         "time": 1524553444,
        //         "name": "QQ\u6d4f\u89c8\u5668\u7b7e\u5230\u793c\u5305",
        //         "level": 3,
        //         "info": "EGWBDAAAAAAUG"
        //     }
        // }, {
        //     "key": 3,
        //     "val": {
        //         "actid": 276364,
        //         "status": 0,
        //         "type": 1,
        //         "is_life_coupon": "0",
        //         "qqvipCardId": 0,
        //         "time": 1524553444,
        //         "name": "QQ\u6d4f\u89c8\u5668\u7b7e\u5230\u793c\u5305",
        //         "level": 2,
        //         "info": "EGWBDAAAAAAUG"
        //     }
        // }, {
        //     "key": 4,
        //     "val": {
        //         "actid": 276364,
        //         "status": 0,
        //         "type": 1,
        //         "is_life_coupon": "0",
        //         "qqvipCardId": 0,
        //         "time": 1524553444,
        //         "name": "QQ\u6d4f\u89c8\u5668\u7b7e\u5230\u793c\u5305",
        //         "level": 1,
        //         "info": "EGWBDAAAAAAUG"
        //     }
        // }];
        if (res.ret == 0) {
          var records = testOp || res.data.op;
          var _htmlArr = [],
              _html = '',
              pageHtml = '',
              PageCount = 0;
          for (var i = records.length - 1; i >= 0; i--) {
            var obj = records[i].val,
                time = qv.date.format("Y-m-d H:i:s", obj.time * 1000),
                name = obj.name,
                level = obj.level,
                cdkey = obj.info ? obj.info : '',
                btn = '';
            if ((level == 1 || level == 2 || level == 3) && cdkey.length !== 16) {
              btn = '<a href="javascript:;" onclick="setUserContact();">填写联系方式</a>';
              cdkey = '-';
            } else if (level == 4 && cdkey.length !== 16) {
              btn = '<a href="http://my.pay.qq.com/account/#index" target="_blank">我的账户</a>';
              cdkey = '-';
            } else {
              btn = '<a href="http://dnf.qq.com/gift.shtml" target="_blank">兑换</a>';
              cdkey = obj.info;
            }
            _htmlArr.push('<tr><td>' + time + '</td><td>' + name + '</td><td>' + cdkey + '</td><td>' + btn + '</td></tr>');
            PageCount++;
          }
          if (PageCount == 0) {
            _htmlArr.push('<tr><td colspan="4" class="noGifts">您尚未获得任何礼包</td></tr>');
          }
          _html = '<table width="100%" class="giftsLists">\
                                    <thead><tr><th>获得时间</th><th>礼包内容</th><th>CDKEY</th><th>操作</th></tr></thead>\
                                    <tbody id="giftsContainer"></tbody>\
                                </table>\
                                <div id="pageContainer"></div>';
          var giftsDialog = new qv.zero.Dialog({
            width: 600,
            title: "查询获奖记录",
            content: _html,
            type: "show",
            buttons: [{
              text: "确定",
              click: function click() {
                giftsDialog.hide();
              }
            }]
          });
          giftsDialog.show();
          var _createPage = window.createPage({
            dataContainer: _htmlArr, //列表数据 Array类型
            liftsContainer: $('#giftsContainer'), //列表容器
            pageContainer: $('#pageContainer'), //分页容器
            backFn: function backFn(p) {
              //解决dialog弹框自动居中，若未使用zMsg弹框，可删除
              $(window).resize();
            }
          });
        } else if (res.ret == 10002) {
          qq.login.open();
        } else if (res.ret == 10001 || res.ret == 10004) {
          zMsg.alert("活动已经结束，敬请期待更多QQ浏览器特权活动！");
        } else {
          zHttp.showResponse(res, res.actid, $.noop);
        }
      });
    });
    _qblog.wsd.click("BROWSER.ACTIVITY.DNF201808.QUERYRECORDCLICK");
  }

});
window.page = new Page();

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var config = {
  'title': 'DNF七夕活动，QQ浏览器送大礼',
  'keywords': 'DNF 七夕 活动',
  'description': 'DNF七夕QQ浏览器送大礼'
};

config.layout = __webpack_require__(3);

__webpack_require__(5);

config.qbtop = [__webpack_require__(6)];

config.qbheader = [];

config.qbbody = [__webpack_require__(8), __webpack_require__(10)];

config.qbfooter = [__webpack_require__(12)];

module.exports = config;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(4);

/***/ }),
/* 4 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 5 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

;
(function (global, document, $) {

  __webpack_require__(7);

  var COOKIE_CONFIG = {
    domain: 'tq.qq.com',
    path: '/',
    expires: 24 * 60 * 60
  };

  function isQQBrowser() {

    return !/Trident/i.test(navigator.userAgent) && /QQBrowser/i.test(navigator.userAgent) && chrome && window.external && window.external.getVersion ? true : false;
  }

  // 初始化登录&用户信息UI
  function initLoginUI(option) {

    var showAvatar = false;
    var loginUIHtml = {
      notLogin: '你好，<a href="#" class="bt_login">请登录</a>',
      isLogin: '<span class="user_nick" title="欢迎">{nick}</span><a id="header-logout" class="mod_st_logout" href="#" title="退出">退出</a>',
      isLoginIcon: '<img class="user_icon" src="{avatar}"/><span class="user_nick">{nick}</span><a id="header-logout" class="mod_st_logout" href="#" title="退出">退出</a>'
    };

    // 绑定登录事件
    var _setLogin = function _setLogin(option) {
      showAvatar = !!option.showAvatar;
      // 登录
      qq.login.bind('login', function () {
        var _uin = qv.cookie.get('_uin');
        var _nick = qv.cookie.get('_nick');
        var _avatar = qv.cookie.get('_avctar');
        // 如果cookie里有_uin，_nick等信息，更新，否则去；拉取
        if (_uin === qq.login.getUin() && _nick && _avatar) {
          _fillUserInfo(_nick, _avatar);
        } else {
          var options = {
            url: 'http://iyouxi3.vip.qq.com/ams3.0.php',
            dataType: 'jsonp',
            data: {
              _c: 'User',
              field: "uin,nickname,faceurl",
              g_tk: qq.security.getCSRFToken()
            },
            success: function success(res, textStatus, jqXHR) {
              qv.cookie.set('_uin', res.data.uin, COOKIE_CONFIG);
              qv.cookie.set('_nick', res.data.nickname, COOKIE_CONFIG);
              qv.cookie.set('_avctar', res.data.faceurl, COOKIE_CONFIG);
              _fillUserInfo(res.data.nickname, res.data.faceurl);
              if (res.data.nickname === undefined) {
                qq.login.logout();
              }
            }
          };
          $.ajax(options);
        }
      });
      // 退出登录
      qq.login.bind('logout', function () {
        pt.logout();
        qv.cookie.clear('_uin');
        qv.cookie.clear('_nick');
        qv.cookie.clear('_avctar');
        _fillUserInfo();
      });
      if (qq.login.getUin()) {
        qq.login.trigger('login');
      } else {
        _fillUserInfo();
      }
    };

    // 设置用户信息到dom
    var _fillUserInfo = function _fillUserInfo(nick, faceurl) {
      var _arHtml = [];
      var _data = {};
      if (nick) {
        _data.nick = qv.string.encodeHTML(nick);
      }
      if (faceurl) {
        _data.avatar = faceurl;
      }
      if (!qq.login.getUin()) {
        _arHtml.push(loginUIHtml.notLogin);
      } else {
        if (showAvatar) {
          _arHtml.push(qv.string.format(loginUIHtml.isLoginIcon, _data));
        } else {
          _arHtml.push(qv.string.format(loginUIHtml.isLogin, _data));
        }
      }
      $('#navUserInfo').html(_arHtml.join(''));
      if (showAvatar) {
        $('#navUserInfo .user_icon').show();
      }
      _bindEvent();
    };
    // events: 登录 | 退出登录
    var _bindEvent = function _bindEvent() {
      $('.bt_login').click(function (e) {
        e.preventDefault();
        pt.showPtui();
      });
      $('.mod_st_logout').click(function (e) {
        e.preventDefault();
        qq.login.logout();
      });
      qq.login.trigger('navrendered');
    };

    qq.login.open = function () {
      pt.showPtui();
    };
    _setLogin(option);
  }

  // 加载&初始化登录组件ptlogin
  function initPtlogin(option) {

    var ptloginParam = {
      'appid': 1600000073,
      'daid': 5,
      's_url': location.href,
      'style': 20,
      'protocol': 'https:',
      'domain': 'qq.com',
      'border_radius': 1,
      'target': 'top',
      'maskOpacity': 40
    };
    if ((typeof option === 'undefined' ? 'undefined' : _typeof(option)) === 'object' && option.qzoneDaid) {
      ptloginParam['daid'] = 5;
    }
    $.getScript('https://xui.ptlogin2.qq.com/js/ptlogin_v1.js', function () {
      pt.setParams(ptloginParam);
    });
  }

  // header初始化
  function initHeader(option) {

    // 加载&初始化登录组件ptlogin
    initPtlogin(option);
    initLoginUI(option);

    // 加载页头UI
    // var headerClass = option.isWhiteStyle ? '' : 'black';
    var $headerQBEle = $('#headerQB');
    // $('#modHeader div.mod-act-header').addClass(headerClass);

    // 非QB显示下载按钮
    if (!isQQBrowser()) {
      $headerQBEle.css('display', 'inline');
    }
    if ((typeof option === 'undefined' ? 'undefined' : _typeof(option)) === 'object') {
      $headerQBEle.attr('href', option.downloadLink || 'http://dldir1.qq.com/invc/tt/QQBrowser_Setup_Privilegecenter.exe');
      if (option.report) {
        $headerQBEle.onclick = function () {
          _qblog.tcss.click(option.report);
        };
      }
    }
  }

  initHeader({
    // 是否白色背景风格 false黑色|true白色（可选，默认false）
    // isWhiteStyle: true,
    // 用户头像是否显示（可选，默认false）
    showAvatar: true,
    // 下载QB按钮的链接 默认：特权中心QB包（可选）
    downloadLink: 'http://dldir1.qq.com/invc/tt/QQBrowser_Setup_Privilegecenter.exe',
    // 点击流数据上报（可选）
    report: 'BROWSER.EVENTS.TOPQBDOWNLOADCLICK'
  });
})(undefined, document, jQuery);

/***/ }),
/* 7 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(9);

/***/ }),
/* 9 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(11);

var _pageUrl = location.protocol + '//' + location.host + location.pathname;
var sixDay = false;

/***/ }),
/* 11 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(13);

/***/ }),
/* 13 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = utils;

function utils() {}

var parseUrlParams = utils.parseUrlParams = function (str) {
  str || (str = '');
  var vars = str.split("&");
  var json = {},
      pair;

  for (var i = 0; i < vars.length; i++) {
    pair = pair.split('=');
    json[pair[0]] = decodeURIComponent(pair[1] || '');
  }
  return json;
};
var getUrlParams = utils.getUrlParams = function (key) {
  var query = window.location.search.substring(1);
  var json = parseUrlParams(query);
  utils.getUrlParams = function (k) {
    return k ? json[k] : json;
  };
  return key ? json[key] : json;
};

utils.animateScrollTo = function (cval, tval, callback) {
  var f = 30,
      dval = tval - cval;

  function __run() {
    dval = dval / 2;
    if (Math.abs(dval) > 1) {
      cval += dval;
      callback(Math.round(cval));
      setTimeout(__run, f);
    } else {
      callback(tval);
    }
  }
  __run();
};
//QQ浏览器判断
utils.isQQBrowser = function () {
  return !/Trident/i.test(navigator.userAgent) && /QQBrowser/i.test(navigator.userAgent) && window.external && window.external.getVersion ? true : false;
};
/**
 * 对日期进行格式化，
 * @param date 要格式化的日期
 * @param format 进行格式化的模式字符串
 *     支持的模式字母有：
 *     y:年,
 *     M:年中的月份(1-12),
 *     d:月份中的天(1-31),
 *     h:小时(0-23),
 *     m:分(0-59),
 *     s:秒(0-59),
 *     S:毫秒(0-999),
 *     q:季度(1-4)
 * @return String
 */
utils.dateFormat = function (date, format) {
  date = new Date(date);

  var map = {
    "M": date.getMonth() + 1, //月份
    "d": date.getDate(), //日
    "h": date.getHours(), //小时
    "m": date.getMinutes(), //分
    "s": date.getSeconds(), //秒
    "q": Math.floor((date.getMonth() + 3) / 3), //季度
    "S": date.getMilliseconds() //毫秒
  };
  format = format.replace(/([yMdhmsqS])+/g, function (all, t) {
    var v = map[t];
    if (v !== undefined) {
      if (all.length > 1) {
        v = '0' + v;
        v = v.substr(v.length - 2);
      }
      return v;
    } else if (t === 'y') {
      return (date.getFullYear() + '').substr(4 - all.length);
    }
    return all;
  });
  return format;
};

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var guid = void 0;
var mask = __webpack_require__(0);

function request() {}
//发送请求
request.send = function (obj, cb) {
  if (!guid) {
    try {
      guid = qbsdk.getGuid(); //window.external.getGuid().split("-").join("")
    } catch (e) {}
  }
  if (qbsdk.isQB() /*api.isQB*/) {
      zUtil.ensureLogin(function () {
        obj.guid = guid;
        zHttp.send(obj, function (res) {
          if (res.ret == 10002) {
            qq.login.open();
          } else if (res.ret == 10004) {
            //todo
          } else {
            cb && cb(res);
          }
        });
      });
    }
  // else {
  //   mask("QBrowser")
  // }
};

module.exports = request;

/***/ }),
/* 16 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 17 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 18 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 19 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 20 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 21 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 22 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 23 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 24 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var csss = __webpack_require__(26);
var template = __webpack_require__(27);
module.exports = Dialog;

var default_options = {
  body: '',
  width: 380,
  height: 0,
  maskclose: true,
  onclose: null,
  onshow: null
};

var $body = $(document.body);
function disabledMouseWheel() {
  function scrollFunc(evt) {
    return false;
  }
  if (document.addEventListener) {
    document.addEventListener('DOMMouseScroll', scrollFunc, false);
  } //W3C
  window.onmousewheel = document.onmousewheel = scrollFunc; //IE/Opera/Chrome
}
function ableMouseWheel() {
  function scrollFuncRecover(evt) {
    return true;
  }
  if (document.addEventListener) {
    document.addEventListener('DOMMouseScroll', scrollFuncRecover, false);
  } //W3C
  window.onmousewheel = document.onmousewheel = scrollFuncRecover; //IE/Opera/Chrome
}
function Dialog(opts) {
  if (!(this instanceof Dialog)) return new Dialog(opts);
  this.opts = $.extend({}, default_options, opts);
  this._createElement();
  this._initEvents();
}

Dialog.prototype = {

  show: function show() {
    var self = this,
        opts = self.opts,
        $el = self.$el,
        $box = self.$box;
    $box.css({
      'width': opts.width,
      'margin-left': -opts.width / 2
    });
    $el.show();

    var h = opts.height > 0 ? opts.height : $box.height();
    self.$box.css({
      'height': h,
      'top': -h / 2,
      'margin-top': -h / 2
    });
    disabledMouseWheel();
    setTimeout(function () {
      self.$el.addClass('active');
    }, 0);
    opts.onshow && opts.onshow();
    return self;
  },

  close: function close() {
    ableMouseWheel();
    var self = this,
        opts = self.opts;
    self.$el.removeClass('active');
    self.$box.hide();
    setTimeout(function () {
      self.$el.hide();
      setTimeout(function () {
        self._destroy();
      }, 500);
    }, 350);
    opts.onclose && opts.onclose();
    return self;
  },

  on: function on() {
    var self = this,
        $el = self.$el;
    $el.on.apply($el, Array.prototype.slice.call(arguments));
    return self;
  },

  find: function find(selector) {
    return this.$box.find(selector);
  },

  _destroy: function _destroy() {
    this.$el.remove();
    this.$el = null;
    this.$box = null;
  },

  _initEvents: function _initEvents() {
    var self = this;
    self.opts.maskclose && self.$el.on('click', 'div.pcqb-dialog-mask', function (e) {
      self.close();
    });
    self.$el.on('click', '.submit', function (e) {
      self.close();
      self.opts.onclose && self.opts.onclose();
    });
    self.$el.on('click', '.close', function (e) {
      self.close();
    });
    self.$el.on('click', '.addres', function (e) {
      self.close();
      self.opts.onclose && self.opts.onclose();
      lottery.getUserContact(); //todo 耦合性太高
    });
  },

  _createElement: function _createElement() {
    var $el = $(template({
      body: this.opts.body
    }));
    this.$el = $el;
    this.$box = $el.find('div.dialog-wrap');
    $body.append($el);
  }

};

/***/ }),
/* 26 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 27 */
/***/ (function(module, exports) {

module.exports = function (obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="dialog-container"><div class="dialog-mask"></div><div class="dialog-wrap"><span class="close">✕</span><div class="dialog-body"> ' +
((__t = (body)) == null ? '' : __t) +
' </div></div></div>';

}
return __p
}

/***/ }),
/* 28 */
/***/ (function(module, exports) {

module.exports = function (obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="dialog-qb-down"><div class="qb-down prize"><p> ' +
((__t = (title)) == null ? '' : __t) +
' </p><p> ' +
((__t = (msg)) == null ? '' : __t) +
' </p><div class="btn"><a class="downQb" id="downloadQBBtn" href="https://dldir1.qq.com/invc/tt/QQBrowser_Setup_QB10.exe" onclick="_qblog.wsd.click(\'RELEASEMEBABY.QBDOWN.CLICK\');">下载QQ浏览器</a></div></div></div>';

}
return __p
}

/***/ }),
/* 29 */
/***/ (function(module, exports) {

module.exports = function (obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="dialog-myGifts"><div class="giftRecord prize"><div class="tit">获奖记录</div><div class="gifts"></div></div></div>';

}
return __p
}

/***/ }),
/* 30 */
/***/ (function(module, exports) {

module.exports = function (obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="dialog-show-prize"><div class="gifts"></div></div>';

}
return __p
}

/***/ }),
/* 31 */
/***/ (function(module, exports) {

module.exports = function (obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="dialog-share-getChance"><div class="notShare sma"><p>抽奖机会已用完，分享给好友可额外获得</p><p>1次抽奖机会哦!</p><div class="logo">分享至： <span class="QZ" onclick="lottery.shareTo(\'qzone\');"></span> <span class="WB" onclick="lottery.shareTo(\'sina\')"></span> <span class="QQ" onclick="lottery.shareTo(\'qq\')"></span></div></div></div>';

}
return __p
}

/***/ }),
/* 32 */
/***/ (function(module, exports) {

module.exports = function (obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="dialog-common"><div class="notSub sma"><p>请订阅后再参与抽奖，据说手气更旺！</p><div class="btn"><a href="javascript:void(0)" onclick="lottery.sub(true);" class="close closeSub">订阅并抽奖</a></div></div></div>';

}
return __p
}

/***/ }),
/* 33 */
/***/ (function(module, exports) {

module.exports = function (obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="dialog-common"><div class="outtime sma"><p> ' +
((__t = (title)) == null ? '' : __t) +
' </p><p> ' +
((__t = (msg)) == null ? '' : __t) +
' </p><div class="btn"><a href="javascript:void(0)" class="close">我知道了</a></div></div></div>';

}
return __p
}

/***/ }),
/* 34 */
/***/ (function(module, exports) {

module.exports = function (obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="dialog-user-contact"><div id="userCon"><div class="tit">填写联系方式</div><div class="userInfo"></div><div class="sub submit" onclick="lottery.setUserContact()">确认提交</div></div><div id="success-submit">提交成功</div></div>';

}
return __p
}

/***/ }),
/* 35 */
/***/ (function(module, exports) {

module.exports = function (obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="dialog-answer-end"><div class="answer-end"><p class="body">需要把4个题答完再交卷哦~</p><div class="btn"><a href="javascript:void(0)" class="close">我知道了</a></div></div></div>';

}
return __p
}

/***/ }),
/* 36 */
/***/ (function(module, exports) {

module.exports = function (obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="dialog-answer-first"><div class="answer-first"><div class="answer-title"><img src="' +
((__t = (headsrc)) == null ? '' : __t) +
'"> <span class="title"> ' +
((__t = (title)) == null ? '' : __t) +
' </span></div><p class="body"> ' +
((__t = (msg)) == null ? '' : __t) +
' </p><div class="btn"><a class="goWatch close" id="goWatch" href="https://v.qq.com/x/cover/vxz0cpf5fawnghw/u0026nf7g8r.html?ptag=qqbrowser&ADTAG=zd-activity" target="_blank">立即去看剧</a></div></div></div>';

}
return __p
}

/***/ }),
/* 37 */
/***/ (function(module, exports) {

module.exports = function (obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="dialog-common dialog-common-littlemask"><div class="hd"> ' +
((__t = (title)) == null ? '' : __t) +
' </div><div class="mask-little-tit-msg"> ' +
((__t = (msg)) == null ? '' : __t) +
' </div><div class="little-flow-btn ft"><button class="close" style="font-size:18px">我知道了</button></div></div>';

}
return __p
}

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* iBorad
 ----------------------------------------------------------------*/
module.exports = iBorad;

function iBorad(element, options) {
  this.defaultOptions = {
    type: 'left',
    speed: 1500,
    cycle: 3600
  };
  this.options = options || {};
  this.options = $.extend({}, this.defaultOptions, this.options);

  this.$element = $(element);
}
var maxWidth_iBorad_item = 0;
iBorad.prototype = {
  constructor: iBorad,
  init: function init() {
    var self = this,
        boxTotalWidth = 0;

    self.$active = this.$element.find('.board-slide .box-active');
    if (self.options.type == 'left') {
      self.$element.find('.board-slide .box').each(function () {
        if ($(this).outerWidth() >= maxWidth_iBorad_item) {
          maxWidth_iBorad_item = $(this).outerWidth();
          //console.log($(this).outerWidth());
        }
        boxTotalWidth += $(this).outerWidth();
      });
      self.$element.find('.board-slide .box').each(function () {
        $(this).width(maxWidth_iBorad_item + 10);
      });
      // self.$element.find('.board-slide').css({width: boxTotalWidth})
    }
    self.next();
    self.isCycle || self.cycle();
  },
  next: function next() {
    var self = this,
        $target = self.$active.next()
    // , curBoxWidth = self.$active.outerWidth()

    ,
        $copyBox = self.$active.clone().removeClass('box-active'),
        slideOpt,
        slideValue;

    switch (self.options.type) {
      case 'left':
        slideValue = '-' + (maxWidth_iBorad_item + 10) + 'px'; // +10 动画移动的距离 加大 补偿margin 最好位置
        slideOpt = {
          marginLeft: slideValue
        };
        break;
      case 'top':
        slideValue = '-' + self.$active.height() + 'px';
        slideOpt = {
          marginTop: slideValue
        };
        break;
      default:
        break;
    }
    self.$active.animate(slideOpt, self.options.speed, 'linear', function () {
      $copyBox.appendTo(self.$element.find('.board-slide'));
      $(this).remove();
    });
    $target.addClass('box-active');
    self.$active = $target;
  },
  cycle: function cycle() {
    var self = this;
    if (!self.isCycle) {
      self.isCycle = setInterval(function () {
        self.next();
      }, self.options.cycle);
    }
  }
};

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 来自 http://stdl.qq.com/stdl/tq_center/activity/common/header_footer_v2.js
// 暂时使用，后面需要替换掉这个旧的

(function ($) {
  var userInfo = {};
  var isQB = isQB = isQQBrowser();

  function getUserInfo(cb) {
    zUtil.ensureLogin(function () {
      $.ajax({
        url: 'http://cgi.vip.qq.com/contact/getusercontact',
        type: "get",
        dataType: "jsonp",
        data: {
          g_tk: qq.security.getCSRFToken()
        },
        jsonp: "callback",
        success: function success(json) {
          if (json.ret === 0) {
            userInfo = {
              name: json.data.NAME,
              phone: json.data.PHONE,
              email: json.data.EMAIL,
              address: json.data.POST_ADDR
            };
            cb ? cb(userInfo) : null;
          } else if (json.ret === -7) {
            qq.login.open();
          } else {}
        }
      });
    });
  };

  function setUserInfo(obj, cb) {
    for (var i in obj) {
      obj[i] = obj[i].trim();
    }
    if (obj.name.length == 0) {
      alert('濮撳悕涓嶈兘涓虹┖锛�');
      return;
    } else if (obj.name.length < 2 || !/^[a-zA-Z\u4e00-\u9fa5]{0,}$/.test(obj.name)) {
      alert('濮撳悕涓嶅悎娉曪紝璇烽噸鏂拌緭鍏ワ紒');
      return;
    }
    if (obj.phone.length == 0) {
      alert('鎵嬫満鍙蜂笉鑳戒负绌猴紒');
      return;
    } else if (obj.phone != userInfo.phone) {
      if (isNaN(obj.phone) || obj.phone.length != 11) {
        alert('璇疯緭鍏ユ湁鏁堢殑鎵嬫満鍙凤紒');
        return;
      }
    }
    if (obj.email.length == 0) {
      alert('鐢靛瓙閭涓嶈兘涓虹┖锛�');
      return;
    } else if (!/^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/.test(obj.email)) {
      alert('璇疯緭鍏ユ湁鏁堢殑鐢靛瓙閭锛�');
      return;
    }
    if (obj.address.length == 0) {
      alert('閭瘎鍦板潃涓嶈兘涓虹┖锛�');
      return;
    } else if (!/^[a-zA-Z0-9\u4e00-\u9fa5]{0,}$/.test(obj.address)) {
      alert('闈炴硶鐨勬眽瀛楀拰鑻辨枃瀛楃锛岃閲嶆柊杈撳叆锛�');
      return;
    }
    var _url = 'http://cgi.vip.qq.com/contact/setusercontact?name=' + obj.name + '&phone=' + obj.phone + '&email=' + obj.email + '&post_address=' + obj.address + '&noChange_phone=';
    if (obj.phone == userInfo.phone) {
      _url += "1";
    } else {
      _url += "0";
    }
    var temp = 0;
    for (var k in obj) {
      if (obj[k] == userInfo[k]) {
        temp++;
      }
    }
    if (temp == 4) {
      cb ? cb() : null;
      return;
    }
    zUtil.ensureLogin(function () {
      $.ajax({
        url: _url,
        type: "get",
        dataType: "jsonp",
        data: {
          g_tk: qq.security.getCSRFToken()
        },
        jsonp: "callback",
        success: function success(json) {
          if (json.ret == 0) {
            cb ? cb() : null;
          } else if (json.ret == -7) {
            qq.login.open();
          } else {}
        }
      });
    });
  }

  function initUserInfo(phone) {
    $('body').on('focus', '#' + phone, function () {
      if ($(this).val() == userInfo.phone) {
        $(this).val('');
      }
    });
    $('body').on('blur', '#' + phone, function () {
      if ($(this).val() == '') {
        $(this).val(userInfo.phone);
      }
    });
  }

  function submitUserInfo(name, phone, email, address, cb) {
    userContact = {
      name: $('#' + name).val(),
      phone: $('#' + phone).val(),
      email: $('#' + email).val(),
      address: $('#' + address).val()
    };
    setUserInfo(userContact, function () {
      cb ? cb() : '';
    });
  }

  function report(hottagValue) {
    window.setTimeout(function () {
      try {
        pgvSendClick({
          hottag: hottagValue
        });
      } catch (e) {}
    }, 100);
  }

  function dataReport(a, b, c, d, e, f, g, h, i) {
    window.setTimeout(function () {
      try {
        window.external.dataReport(a, b, c, d, e, f, g, h, i);
      } catch (e) {
        console.log(e);
      }
    }, 100);
  }
  window.setTimeout(function () {
    if (typeof pgvMain == 'function') {
      pgvMain("pathtrace", {
        pathStart: true,
        tagParamName: "ADTAG",
        useRefUrl: true,
        override: true,
        careSameDomainRef: false
      });
    }
  }, 1000);

  function getQBVersion() {
    var version = 0;
    try {
      try {
        version = window.external.getVersion() || 1;
      } catch (e) {
        version = window.external.getbrowserversion() || 1;
      }
    } catch (e) {
      version = /QQBrowser/.test(navigator.userAgent) || "100.0.0.0";
    }
    return version;
  }

  function isQQBrowser() {
    var version = getQBVersion();
    var result = version != "100.0.0.0" && version != 0;
    isQQBrowser = function isQQBrowser() {
      return result;
    };
    return result;
  }

  window.api = {
    setUserInfo: setUserInfo,
    getUserInfo: getUserInfo,
    initUserInfo: initUserInfo,
    submitUserInfo: submitUserInfo,
    report: report,
    dataReport: dataReport,
    getQBVersion: getQBVersion,
    isQQBrowser: isQQBrowser,
    isQB: isQB
  };
})(jQuery);

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// index.js